import { computed, reactive, watch } from 'vue'
import { useAuthState } from '~/composables/useAuthState'
import { useIncentives } from '~/components/mm/creator/incentives/useIncentives'
import { createInvitationVisit } from '~/components/mm/creator/incentives/invitationVisit'
export function useInvitationObserver() {
  const { isAuthReady, isAuthenticated, user, fetchAndStoreToken } = useAuthState()
  const { session } = useSession()
  const { state, invalidate } = useIncentives()
  const config = useRuntimeConfig()
  const identity = computed(() => isAuthReady.value && isAuthenticated.value && user.value?.id && session.value?.id ? `${user.value.id}:${session.value.id}` : '')
  const enabled = () => {
    try { return !!config.public.invitationWebOrigin && new URL(String(config.public.invitationWebOrigin)).origin === window.location.origin } catch { return false }
  }
  const visit = createInvitationVisit(reactive({ phase: 'idle', error: null, retryAt: 0 }), {
    enabled, uuid: () => crypto.randomUUID(), storage: () => sessionStorage, token: fetchAndStoreToken,
    fetch: (...args) => fetch(...args), subject: () => state.subject, invalidate: () => invalidate('identity_changed'),
  })
  watch([identity, isAuthReady], ([value, ready]) => visit.setIdentity(value, ready), { immediate: true, flush: 'sync' })
  useNuxtApp().provide('invitationVisit', { ...visit, enabled, ready: isAuthReady })
}
